// extracted by mini-css-extract-plugin
export default {"external":"a8abir","tag":"b8abir","text":"c8abir","block":"d8abir"};